import { ownerKeyOf } from "@/api/session";
import { FIELD_LEAD_PATH, isTabPath } from "@/app/navigation";
import { useSession } from "@/app/session";
import { BottomNav } from "@/screens/shell/BottomNav";
import { SessionNotice } from "@/screens/shell/SessionNotice";
import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { initFieldLeadHistory } from "./history";

export function FieldLeadLayout() {
  const session = useSession();
  const location = useLocation();
  const ownerKey = ownerKeyOf(session.user.tenant_id, session.user.id);

  useEffect(() => {
    void initFieldLeadHistory(ownerKey);
  }, [ownerKey]);

  if (!isTabPath(location.pathname)) {
    return <Navigate to={FIELD_LEAD_PATH} replace />;
  }

  return (
    <div className="shell">
      <main className="shell__content">
        <SessionNotice />
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
